import { Injectable } from '@angular/core';

export class List {
    id: number;
    text: string;
    icon: string;
}

let navigation: List[] = [
    
    { id: 0, text: "taskaction-component", icon: "product" },
    { id: 1, text: "Invia Email", icon: "product" },
    { id: 2, text: "Estratto Conto", icon: "money" },
    { id: 3, text: "Invia Documento", icon: "group" },
    { id: 4, text: "Lista Conferimenti", icon: "card" },
    { id: 5, text: "Progressivo Mensile", icon: "chart" }];

let text: string = `

`;

@Injectable()
export class ServiceTaskAction {
    getNavigationList(): List[] {
        return navigation;
    }

    getContent(): string {
        return text;
    }
}
